import { render, staticRenderFns } from "./UsersForm.vue?vue&type=template&id=280b6e72&scoped=true"
import script from "./UsersForm.vue?vue&type=script&lang=js"
export * from "./UsersForm.vue?vue&type=script&lang=js"
import style0 from "./UsersForm.vue?vue&type=style&index=0&id=280b6e72&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "280b6e72",
  null
  
)

export default component.exports